export default "__VITE_ASSET__ChznjRuk__"